import React, { useState } from 'react';

import CloseIconComponent from "../../reusable/CloseIconComponent";
import { useDispatch, useSelector } from "react-redux";
import { closeShareStatus } from "../../../store/layouts/actions";
import ApplyButtons from "../../reusable/ApplyButtons";
import { ApplicationState } from "../../../store";
import { RecordingState } from "../../../store/recordings/types";
import { doCopyText } from "../../../utils";
import './style.scss';

const {CONFIG} = window;


interface Props {
}

const ExportShareComponent: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const {shareAviID} = useSelector<ApplicationState, RecordingState>(state => state.recording);
  const [host, setHost] = useState(CONFIG.ServerAddress);
  const [port, setPort] = useState(CONFIG.ServerPort);

  const closeHandler = () => dispatch(closeShareStatus());

  const onSubmit = (e: React.MouseEvent | React.FormEvent) => {
    e.preventDefault();
    doCopyText('https://' + host + ':' + port + '/avi/' + shareAviID + '.avi');
    dispatch(closeShareStatus())
  };

  return (
    <div className='export-share'>
      <div className='export-share__title'>
        <h2>Share AVI Link</h2>
        <CloseIconComponent handler={closeHandler}/>
      </div>

      <div className='export-share__content'>
        <div className='export-share-content__descr'>
          You are attempting to share a file from localhost.
          This link will not work from another machine.
          You can enter a different IP and port if you like.
        </div>
        <form id="export-form" className='export-share-content__form' onSubmit={onSubmit}>
          <span>https://</span>
          <input type="text"
                 value={host}
                 className={'mr-3'}
                 id={'export-host-id'}
                 onChange={(e) => setHost(e.currentTarget.value)}
          />
          <input type="text"
                 value={port}
                 className={'mr-5'}
                 id={'export-port-id'}
                 onChange={(e) => setPort(e.currentTarget.value)}
          />
        </form>

        <ApplyButtons OKHandler={onSubmit}
                      cancelHandler={closeHandler}
                      disable={false}
        />
      </div>
    </div>
  );
};

export default ExportShareComponent;